import ArticleStockLocationType from "../../entities/ArticleStockLocationType";

class ArticleStockResponse {
    public id: string;
    public agencyId: string;
    public articleId: string;
    public articleName: string;
    public articleDefaultImage: string;
    public entityId: string;
    public entityName: string;
    public unit: string;
    public locationType: ArticleStockLocationType;
    public amount: number;
    public blockedAmount: number;
    public availableAmount: number;
    public assignedAmount: number;
    public damagedAmount: number;

    constructor(
        id: string,
        agencyId: string,
        articleId: string,
        articleName: string,
        articleDefaultImage: string,
        entityId: string,
        entityName: string,
        unit: string,
        locationType: ArticleStockLocationType,
        amount: number,
        blockedAmount: number,
        availableAmount: number,
        assignedAmount: number,
        damagedAmount: number
    ) {
        this.id = id;
        this.agencyId = agencyId;
        this.articleId = articleId;
        this.articleName = articleName;
        this.articleDefaultImage = articleDefaultImage;
        this.entityId = entityId;
        this.entityName = entityName;
        this.unit = unit;
        this.locationType = locationType;
        this.amount = amount;
        this.blockedAmount = blockedAmount;
        this.availableAmount = availableAmount;
        this.assignedAmount = assignedAmount;
        this.damagedAmount = damagedAmount;
    }
}

export default ArticleStockResponse;